import { atom } from 'jotai';

export const isMagicLinkUserAtom = atom(false);
